import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useSelector } from "react-redux";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { useAppDispatch } from "../Core/store.hooks";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import VideoDemos from "./VideoDemos";
import MasterInfo from "../Common/InfoMaster";
import { uniq, map, flatten, sortBy } from "lodash";
import { Input } from "@progress/kendo-react-inputs";
import SiteMap from "../Common/SiteMap";
import { appName } from "../Common/Constants";
import { useLocation, useNavigate } from "react-router-dom"

interface listItemProps {
  title: string;
    content: string;

}
interface infoProps {
    category: string,
    toggleVisible:any

}
const ListItem = (props: listItemProps) => {
  return (
    <div style={{ marginTop: "20px" }}>
      <p style={{ fontWeight: "bold" }}>{props.title}</p>
      <p>{props.content}</p>
    </div>
  );
};
interface searchItemProps {
    title: string;
    content: string;
    link: string,
    route: string,
    group: string,
    toggleVisible:any

}
const SearchItem = (props: searchItemProps) => {
    const navigate = useNavigate();
    let link: any = "";
    const openRoute = (route: string) => {
        props.toggleVisible();
        navigate("/" + route);
      
    }
    if (props.group == appName) {
        link = <span onClick={() => openRoute(props.route)}>Click To Open {props.title}</span>
    }
    else {
        link = <a href={props.link}> Click To Open {props.group} {props.title}</a>
    }
    if (props.route == "") link = "";
    return (
        <div style={{ marginTop: "20px" }}>
            <p style={{ fontWeight: "bold" }}>{props.title}</p>
            <p>{props.content}</p>
            <p style={{color:"blue",cursor:"pointer"} }>{link}</p>
        </div>
    );
};
const Information = (props:infoProps) => {
    const [selected, setSelected] = useState(0);
    const [searchValue, updateSearchValue] = useState(null);

  const handleSelect = (e: any) => {
    setSelected(e.selected);
    };
    const checkSearch = (obj: any) => {
        // Split the searchValue string into an array of lowercase words
        const searchWords = searchValue.toLowerCase().split(" ");

        // Check if every word in searchWords is included in any of the object's properties or arrays
        const isEveryWordPresent = searchWords.every((word) => {
            // Check direct string properties for the current word
            if (obj.type.toLowerCase().includes(word) ||
                obj.group.toLowerCase().includes(word) ||
                obj.title.toLowerCase().includes(word) ||
                obj.content.toLowerCase().includes(word)) {
                return true;
            }

            // Check array properties for the current word
            if (obj.categorys && obj.categorys.some(category => category.toLowerCase().includes(word)) ||
                obj.tags && obj.tags.some(tag => tag.toLowerCase().includes(word))) {
                return true;
            }

            // If the current word is not found in any of the checked properties, return false
            return false;
        });

        // Only return true if every word is present
        return isEveryWordPresent;
    }
    const createList = (listType, group) => {
        // Filter MasterInfo first, then check if the list is non-empty to decide on rendering
        let filteredItems: any = null;
        if (listType != "sitemap") {
           filteredItems = MasterInfo.filter(item =>
                item.type === listType &&
                item.group === group &&
                (searchValue != null ? checkSearch(item) : true))
            
        } else {
            filteredItems = SiteMap.filter(item =>
                item.type === listType &&
                item.group === group &&
                (searchValue != null ? checkSearch(item) : true))
        };

        if (filteredItems.length === 0) {
            // If there are no items to show, return null or an empty fragment
            return null;
        }
        if (listType == "sitemap") {
            return (
                filteredItems.map((Item, index) => (
                    <SearchItem
                        key={index}
                        title={Item.title}
                        content={Item.content}
                        group={Item.group}
                        route={Item.route}
                        link={Item.link}
                        toggleVisible={props.toggleVisible}
                    />
                ))
            );
        }
        // Render the list if there are items
        return (
            filteredItems.map((faqItem, index) => (
                <ListItem
                    key={index}
                    title={faqItem.title}
                    content={faqItem.content}
                />
            ))
        );
    };

    const createLists = (listType) => {
        let uniqueGroups = sortBy(uniq(map(MasterInfo, 'group')));
        if (listType == "sitemap") uniqueGroups = sortBy(uniq(map(SiteMap, 'group')));
        return (
            uniqueGroups.map((group, index) => {
                // Create the list first to check if it's empty
                const list = createList(listType, group);
                if (!list) {
                    // If list is empty, don't render the group and list
                    return null;
                }
                return (
                    <React.Fragment key={index}>
                        <h5>{group}</h5>
                        {list}
                    </React.Fragment>
                );
            })
        );
    };

    const handleSearchChange = (event) => {
        // Update the searchValue state with the current input's value
        updateSearchValue(event.target.value);
    };
    return (
        <><div style={{marginBottom:"20px"} }>
            <Input
                placeholder="Search..."
                style={{ width: "100%" }}
                onChange={handleSearchChange }
            />
        </div>
    <TabStrip
      selected={selected}
      onSelect={handleSelect}
      style={{ maxHeight: "500px" }}
    >
                <TabStripTab title="Navigation">
                    {createLists("sitemap")}
                </TabStripTab>
      <TabStripTab title="FAQ">
              {createLists("faq") }
      </TabStripTab>
   <TabStripTab title="Definitions">
                    {createLists("definition")}
                </TabStripTab>
                <TabStripTab title="Data Types">
                    {createLists("dataTypes")}
                </TabStripTab>
      {/*<TabStripTab title="Video Demos">*/}
      {/*  <div>*/}
      {/*    <VideoDemos />*/}
      {/*  </div>*/}
      {/*</TabStripTab>*/}
            </TabStrip>
        </>
  );
};

export default Information;
